import React, { useEffect, useState } from "react";
import { TeleRolesForm } from "./TeleRolesForm";
import { Plus, SquarePen, Trash2 } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "../../../../utils/pagination/Pagination";
import { pageData } from "../../../../utils/paginationConfig.js";
// import { getDepartment } from "../../../../redux/reduxApi/departmentReduxApi.js";
import { getTeleRoles } from "../../../../redux/reduxApi/teleRolesReduxApi.js";
import { deleteTeleRolesAction } from "../../../../redux/reduxSlice/TeleRolesSlice.js";
// import { deleteDepartment, countDepartment } from "../../../../redux/api/department/deparmentApi.js";
import { deleteTeleRoles,countTeleRoles } from "../../../../redux/api/teleRoles/TeleRolesApi.js";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import TeleRolesMobile from "./TeleRolesMobile.js";

import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  ModalFooter,
  Textarea,
  background,
  border,
  FormLabel,
  Spinner,
  useStepContext,
} from "@chakra-ui/react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import EllipsisMenu from "../../../../utils/EllipsisDropdown/EllipsisMenu.js";
import { useRef } from "react";
import { formatDate } from "../../../../utils/commonFunction/CommonFunction.js";
// import DepartmentMobile from "./mobileList/DepartmentMobile.js";
export default function TeleRolesList() {
  const [isDepartment, setIsDepartment] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const getTeleRoledata = useSelector((state) => state.teleRole.teleRole);
  const userList = useSelector((state) => state.utils.userList);
  
  const [teleRolesData, setTeleRolesData] = useState([]);
  // console.log("teleRolesData",teleRolesData);
  
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [departmentId, setDepartmentId] = useState("");
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const tableRef = useRef(null);
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const [ismobile, setIsmobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setTeleRolesData(getTeleRoledata);
  }, [getTeleRoledata]);


  

  // Get department
  useEffect(() => {
    const page = 1;
    setLoading(true);
    dispatch(getTeleRoles({ page: currentPage, limit: 30, size: 30 }))
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {}, [300]);
      });
  }, [dispatch, currentPage]);

  useEffect(() => {
    if (teleRolesData && teleRolesData.length > 0) {
      setData(teleRolesData);
    }
  }, [teleRolesData]);

  useEffect(() => {
    if (currentPage % pageData.apiHit === 0) {
      const page = currentPage / pageData.apiHit + 1;
      dispatch(getTeleRoles(page));
    }
  });

  // for Trash modal
  const openTrash = () => {
    setIsOpen(true);
  };
  // total companies count
  const fetchTotalCount = async () => {
    try {
      const response = await countTeleRoles();
      const count = parseInt(response.data.count, 10);
      setTotalCount(count);
    } catch (error) {
      console.error("Error fetching total Attendance count:", error);
    }
  };

  useEffect(() => {
    fetchTotalCount();
  }, []);
  const closeTrash = () => {
    setIsOpen(false);
  };
  const openDepartmentDrawer = () => {
    setIsDepartment(true);
  };
  const closeDepartment = () => {
    setIsDepartment(false);
  };
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    const idsToDelete = selectedRows.length === 0 ? [deleteId] : selectedRows;
    Promise.all(idsToDelete.map((id) => deleteTeleRoles(id)))
      .then(() => {
        setData((prevData) => prevData.filter((item) => !idsToDelete.includes(item?.ROWID)));
        console.log("idsToDelete", idsToDelete);
        dispatch(deleteTeleRolesAction(idsToDelete));
        fetchTotalCount();
        toast.success("Row Deleted successfully");
        fetchTotalCount();
      })
      .catch((error) => {
        console.log(error);
        toast.error("Row not deleted");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setDeleteId("");
      });
  };

  // Single Select
  const handleRowSelect = (ROWID) => {
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];
    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter((rowDepartment) => rowDepartment !== ROWID);
    }
    setSelectedRows(newSelectedRows);
    setDeleteId(newSelectedRows.join(","));
  };
  // All Select
  const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === teleRolesData.length;
    let newSelectedRows = [];
    if (!allSelected) {
      newSelectedRows = teleRolesData.map((item) => item?.ROWID);
    }
    setSelectedRows(newSelectedRows);
  };

  // function to check screen size and show hide contente
  const handleResize = () => {
    if (window.innerWidth < 600) {
      desktopRef.current.classList.add("d-none");
      mobileRef.current.classList.remove("d-none");
      setIsmobile(true);
    } else {
      desktopRef.current.classList.remove("d-none");
      mobileRef.current.classList.add("d-none");
      setIsmobile(false);
    }
  };
  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

      const ownerName = (id) => {
        const employeeData = userList.filter((item) => item?.employees?.ROWID === id);
        console.log("employeeData--->", employeeData)
        return employeeData[0]?.employees?.employeeName
    }




  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="purple.500" />
        </div>
      )}
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{/* Optional body content */}</ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrash}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <div ref={desktopRef} style={{ maxHeight: ismobile ? "98vh" : "80vh" }}>
        <div className="d-flex justify-content-end">
          <button className="new-button mx-2" onClick={openDepartmentDrawer}>
            <Plus size="18px" />
            <span className="ms-1">New</span>
          </button>
        </div>
        <div className="custom-scroll leadListConatainer" style={{ maxHeight: "75vh", backgroundColor: "#F3F3F3" }}>
          <TableContainer
            className="card card-detail mt-1 scrollable-container"
            style={{
              maxHeight: "70vh",
              position: "relative",
              overflowY: "scroll",
              scrollbarColor: "#A0AEC0 #EDF2F7",
              scrollbarWidth: "10px",
            }}
            ref={tableRef}
          >
            <ReactHTMLTableToExcel id="test-table-xls-button" className="download-table-xls-button d-none" table="table-to-xls" filename="Lead List" sheet="tablexls" buttonText="Export" />
            <Table id="table-to-xls" className="leadNoPadding" variant="simple" size="sm" stickyHeader style={{ whiteSpace: "nowrap", backgroundColor: "white" }}>
              <Thead>
                <Tr className="tr-border">
                  <Th className="py-1 th-color" style={{ width: "50px" }}>
                    <Checkbox isChecked={selectedRows?.length === teleRolesData?.length} onChange={handleSelectAllRows} />
                  </Th>
                  <Th className="py-1 th-color sticky-column" style={{ width: "80px" }}>
                    Actions
                  </Th>
                  <Th className="py-1 th-color" style={{ width: "150px" }}>
                    Telesale Manager
                  </Th>
                  <Th className="py-1 th-color" style={{ width: "150px" }}>
                   Telesale Owner
                  </Th>
                  <Th className="py-1 th-color sticky-column" style={{ width: "80px" }}>
                    Created Time
                  </Th>
                  <Th className="py-1 th-color sticky-column" style={{ width: "80px" }}>
                    Modified Time
                  </Th>
                  
                </Tr>
              </Thead>
              <Tbody>
                {teleRolesData &&
                  teleRolesData?.map((item, idx) => (
                    <Tr className="tr-border" key={idx} style={{ cursor: "pointer", position: "relative" }}>
                      <Td className="font-colors py-1">
                        <Checkbox
                            isChecked={selectedRows.includes(item?.ROWID)}
                            onChange={() => handleRowSelect(item?.ROWID)}
                        />
                      </Td>
                      <Td className="d-flex" style={{ borderBottom: "none" }}>
                        <SquarePen
                          color="#ff176b"
                          size="16px"
                          strokeWidth="1"
                          className="mx-1"
                          onClick={() => {
                            openDepartmentDrawer(item);
                            setDataToEdit(item);
                            console.log("itemssss",item);
                            
                            setIsUpdateMode(true);
                          }}
                        />
                        <Trash2
                          color="#ff176b"
                          size="16px"
                          strokeWidth="1"
                          onClick={(e) => {
                            openTrash(e);
                            setDeleteId(item?.ROWID);
                          }}
                        />
                      </Td>
                      <Td className="font-colors py-1">{ownerName(item?.teleSalesManager)}</Td>
                      <Td className="font-colors py-1">{ownerName(item?.teleSalesOwner)}</Td>
                      <Td className="font-colors py-1">{formatDate(item?.CREATEDTIME)}</Td>
                      <Td className="font-colors py-1">{formatDate(item?.MODIFIEDTIME)}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
        <div className="footer d-flex fixed-bottom start-20">
          <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
            <p class="fw-semibold">Total Count: {teleRolesData?.length}</p>
          </div>
          {/* Pagination */}
          <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
            <Pagination totalPages={Math.ceil(totalCount / 30)} onPageChange={setCurrentPage} />
          </div>
        </div>
        <TeleRolesForm
          isDepartment={isDepartment}
          closeDepartment={closeDepartment}
          dataToEdit={dataToEdit}
          isUpdateMode={isUpdateMode}
          setIsUpdateMode={setIsUpdateMode}
          // departmentId={departmentId}
        />
      </div>
      <div ref={mobileRef} style={{ maxHeight: "100vh" }} className="d-none">
        <TeleRolesMobile
          teleRolesData={teleRolesData}
          openDepartmentDrawer={openDepartmentDrawer}
          openTrash={openTrash}
          ownerName={ownerName}
          setDataToEdit={setDataToEdit}
          setIsUpdateMode={setIsUpdateMode}
          totalCount={totalCount}
          setDeleteId={setDeleteId}
          setDepartmentId={setDepartmentId}
          formatDate={formatDate}
        />
      </div>
    </>
  );
}
